
<template>
  <div
    class="show-for-large"
  ></div>
</template>
<script>
export default {
  props: {
    payload: {
      default: () => {}
    },
  }
};
</script>